<template>
  <div>
    <mad-list-item ref="testEL" style="height: 44px; width: 100%" :class="{ active: internalValue }">
      <mad-icon
        @click="toggleChild"
        v-if="item.child && item.child.length"
        style="left: -8px; margin: 0;"
        :class="{
          'color-grey-700': !internalValue,
          'color-grey-100': internalValue,
        }"
        slot="firstIcon"
        name="mdiArrowRight"
      ></mad-icon>
      <div v-else style="width: 24px; height: 32px; left: -8px; margin: 0;" slot="firstIcon"></div>
      <mad-checkbox
        :disabled="disabled || disabledItem.includes(item.id)"
        v-model="internalValue"
        style="top: -12px; border: 0"
        :label="item.name"
        :class="{ invert: internalValue }"
      ></mad-checkbox>
    </mad-list-item>
    <mad-tree
      :disabledItem="disabledItem"
      ref="tree"
      :disabled="disabled"
      :value="value"
      :data="item.child"
      style="margin-left: 44px; overflow-y: hidden"
      :is-root="false"
      :root="root"
    ></mad-tree>
  </div>
</template>

<script>
import Helper from "../helper";
export default {
  props: {
    item: {},
    root: {},
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledItem: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      internalValue: false,
    };
  },
  methods: {
    hide() {
      this.$refs.tree.$el.style.maxHeight = "0";
      this.isHide = true;
    },
    show() {
      this.$refs.tree.$el.style.maxHeight = this.$refs.tree.$el.scrollHeight + "px";
      this.isHide = false;
    },
    toggleChild(e) {
      Helper.toggleClass(e, "open");
      this.isHide ? this.show() : this.hide();
    },
  },
  watch: {
    internalValue(val) {
      if (val) {
        this.root.addValue(this.item.id, this);
      } else {
        this.root.removeValue(this.item.id, this);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value.includes(this.item.id)) {
        this.internalValue = true;
      }
    });
  },
};
</script>
